export default {
    menuItems: [
      {
        name: 'HOME',
        url: '/'
      },
      {
        name: 'ABOUT',
        url: '/about'
      },
      {
        name: 'COMPANY',
        url: '/company'
      },
      {
        name: 'BUSINESS',
        url: '/business'
      },
      {
        name: 'CONTACT',
        url: '/contact'
      }
    ]
  }